import React from 'react';
import { Link } from 'react-router-dom';

function ProfilePage() {
  const companies = [
    { name: 'Kasango AI', desc: 'AI-powered Forex trading ecosystem' },
    { name: 'CashBet AI', desc: 'Next-generation Aviator predictor and gaming intelligence app' },
    { name: 'GhattiNet', desc: 'Telecom brand offering web hosting, data bundles, and business numbers' },
    { name: 'Ghatti Visual & Interiors', desc: 'Luxury architecture and design firm' },
    { name: 'BrightMarks & Teacher App', desc: 'Educational AI systems powered by adaptive learning' }
  ];

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-lg border-b border-zinc-800">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-white/20">
              <img
                src="https://customer-assets.emergentagent.com/job_b9ac4c36-714b-45c0-9160-f047c039178c/artifacts/vio7h01p_image.png"
                alt="John Ghatti"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="text-xl font-light tracking-wide">JOHN GHATTI</span>
          </Link>
          
          <Link to="/" className="px-6 py-2 border border-zinc-700 text-sm hover:bg-zinc-800 transition-colors">
            BACK TO HOME
          </Link>
        </div>
      </header>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6 border-b border-zinc-800">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row gap-12 items-start">
            {/* Profile Image */}
            <div className="w-64 h-64 flex-shrink-0 border-4 border-white">
              <img
                src="https://customer-assets.emergentagent.com/job_b9ac4c36-714b-45c0-9160-f047c039178c/artifacts/vio7h01p_image.png"
                alt="John Ghatti"
                className="w-full h-full object-cover grayscale"
              />
            </div>

            {/* Profile Info */}
            <div className="flex-1">
              <h1 className="text-6xl font-extralight tracking-tight mb-6">JOHN GHATTI</h1>
              
              <div className="space-y-3 text-gray-400 font-light mb-8">
                <div><span className="text-white font-medium">Born:</span> Johannesburg, South Africa</div>
                <div><span className="text-white font-medium">Nationality:</span> South African</div>
                <div><span className="text-white font-medium">Occupation:</span> Entrepreneur · AI Developer · Forex Expert · Civil Engineer · Property Investor</div>
                <div><span className="text-white font-medium">Known for:</span> Founding Kasango AI, CashBet AI, and GhattiNet</div>
                <div><span className="text-white font-medium">Years Active:</span> 2015–present</div>
                <div><span className="text-white font-medium">Website:</span> <a href="http://www.JohnGhatti.co.za" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">www.JohnGhatti.co.za</a></div>
              </div>

              {/* Social Links */}
              <div className="flex flex-wrap gap-3">
                <a href="https://www.instagram.com/john_ghatti__ceo_?igsh=MWM2NmYxdXV0a25naw%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="px-4 py-2 border border-zinc-700 text-sm hover:bg-zinc-800 transition-colors">
                  INSTAGRAM
                </a>
                <a href="https://youtube.com/@johnghattiworldwide" target="_blank" rel="noopener noreferrer" className="px-4 py-2 border border-zinc-700 text-sm hover:bg-zinc-800 transition-colors">
                  YOUTUBE
                </a>
                <a href="https://t.me/winnersgroundPwR1" target="_blank" rel="noopener noreferrer" className="px-4 py-2 border border-zinc-700 text-sm hover:bg-zinc-800 transition-colors">
                  TELEGRAM
                </a>
                <a href="https://www.tiktok.com/@johnghatti?_t=ZS-90nnpBKxySK&_r=1" target="_blank" rel="noopener noreferrer" className="px-4 py-2 border border-zinc-700 text-sm hover:bg-zinc-800 transition-colors">
                  TIKTOK
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 px-6 border-b border-zinc-800">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl font-extralight tracking-tight mb-8">ABOUT</h2>
          <div className="space-y-6 text-gray-400 font-light leading-relaxed text-lg">
            <p>
              John Ghatti is a South African entrepreneur, civil engineer, and AI developer best known for pioneering 
              <span className="text-white font-medium"> Forex Artificial Intelligence systems in Africa</span>.
            </p>
            <p>
              A Civil Engineering graduate with honours from the University of Johannesburg, he has combined technical precision, 
              data science, and creativity to build a powerful ecosystem of fintech and technology companies.
            </p>
            <p>
              Ghatti is the founder of <span className="text-white font-medium">Kasango AI</span>, an AI-powered Forex trading ecosystem, 
              and the creator of <span className="text-white font-medium">CashBet AI</span>, an intelligent Aviator and gaming predictor. 
              He also leads <span className="text-white font-medium">GhattiNet</span>, a telecom and web hosting company designed to revolutionize Africa's connectivity landscape.
            </p>
          </div>
        </div>
      </section>

      {/* Early Life & Education */}
      <section className="py-20 px-6 border-b border-zinc-800">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl font-extralight tracking-tight mb-8">EARLY LIFE & EDUCATION</h2>
          <div className="space-y-6 text-gray-400 font-light leading-relaxed text-lg">
            <p>
              John Ghatti's journey began with a strong foundation in <span className="text-white font-medium">Civil Engineering</span>, 
              where he graduated with honours from the <span className="text-white font-medium">University of Johannesburg</span>.
            </p>
            <p>
              His engineering background instilled a deep understanding of system design, data logic, and structural precision — 
              skills he later adapted into algorithmic trading and AI development.
            </p>
          </div>
        </div>
      </section>

      {/* Career & Innovations */}
      <section className="py-20 px-6 border-b border-zinc-800">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl font-extralight tracking-tight mb-8">CAREER & INNOVATIONS</h2>
          <div className="space-y-8">
            {companies.map((company, index) => (
              <div key={index} className="border-l-2 border-white pl-6">
                <h3 className="text-2xl font-light mb-2">{company.name}</h3>
                <p className="text-gray-400 font-light">{company.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Leadership & Influence */}
      <section className="py-20 px-6 border-b border-zinc-800">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl font-extralight tracking-tight mb-8">LEADERSHIP & INFLUENCE</h2>
          <div className="space-y-6 text-gray-400 font-light leading-relaxed text-lg">
            <p>
              John Ghatti is widely regarded as the <span className="text-white font-medium">pioneer of Forex AI and automated trading systems in Africa</span>, 
              having built one of the continent's most recognized Forex AI brands.
            </p>
            <p>
              His work has inspired a new generation of African traders, programmers, and investors who view technology as the bridge 
              between innovation and financial independence.
            </p>
            <p>
              As a property investor, Ghatti has also expanded into <span className="text-white font-medium">real estate development and luxury architecture</span>, 
              merging his engineering expertise with a passion for design and modern living spaces.
            </p>
          </div>
        </div>
      </section>

      {/* Philosophy & Brand Vision */}
      <section className="py-20 px-6 border-b border-zinc-800">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl font-extralight tracking-tight mb-8">PHILOSOPHY & BRAND VISION</h2>
          <div className="space-y-6 text-gray-400 font-light leading-relaxed text-lg">
            <p>
              John Ghatti represents the <span className="text-white font-medium">new face of African innovation</span> — 
              where technology meets creativity, and vision meets execution.
            </p>
            <p>
              His signature projects fuse AI, architecture, and automation, shaping Africa's next wave of tech-driven industries.
            </p>
          </div>

          {/* Quote */}
          <div className="mt-12 border-l-4 border-white pl-8">
            <blockquote className="text-2xl font-light italic text-white mb-4">
              "We're not just building systems — we're building the future."
            </blockquote>
            <p className="text-gray-500">— JOHN GHATTI</p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 px-6">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-4xl font-extralight tracking-tight mb-8">GET IN TOUCH</h2>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="https://wa.me/27685358462" target="_blank" rel="noopener noreferrer" className="px-8 py-3 bg-white text-black font-medium hover:bg-gray-200 transition-colors">
              WHATSAPP
            </a>
            <a href="https://t.me/winnersgroundPwR1" target="_blank" rel="noopener noreferrer" className="px-8 py-3 border border-white text-white font-medium hover:bg-white hover:text-black transition-colors">
              TELEGRAM
            </a>
            <a href="mailto:Winnersgroundfx@gmail.com" className="px-8 py-3 border border-zinc-700 text-white font-medium hover:bg-zinc-800 transition-colors">
              EMAIL
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ProfilePage;
